import React, { useState, useEffect } from "react";
import "./LandingPage.css";

import OfferPage from "./Components/LeadCaptureForm/OfferSection/OffersPage";
import { useSearchParams } from "react-router-dom";
import { setUserClickData } from "../../utility/setUserClickData";
import { useSelector, useDispatch } from "react-redux";
import { setLead, setOffers } from "../../store/app/appReducer";
import callApi from "../../utility/apiCaller";
import Header from "./Components/Header/Header";
import { toast } from "react-toastify";
import _ from "lodash";

const LandingPage = () => {
  const [isFormStarted, setIsFormStarted] = useState(false);
  const [showOfferHeaderLogo, setShowOfferHeaderLogo] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({});
  const [params] = useSearchParams();
  const affId = params.get("aff_id") || "";
  const leadId = params.get("lid") || "";
  const utmSource = params.get("utm_source") || "";
  const source = params.get("source") || "";
  const utmMedium = params.get("utm_medium") || "";
  const utmTerm = params.get("utm_term") || "";
  const adsName = params.get("ads_name") || "";
  const dispatch = useDispatch();
  const [failedList,setFailedList] = useState([])

  useEffect(() => {
    window.onbeforeunload = () => {
      sessionStorage.removeItem("isFormStarted");
    };

    const sessionFlag = sessionStorage.getItem("isFormStarted");
    if (sessionFlag === "true") {
      setIsFormStarted(true);
    }
    setUserClickData({
      event_name: `pageview-check-offers-v5-${utmSource || "fb"}`,
      user_id: "No User ID found here",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
    });
    console.log(leadId);
    if (leadId) {
      getLntDefaultOffer();
    }
  }, []);

  const getLntDefaultOffer = async () => {
    if (!leadId) return false;

    try {
      // 1️⃣ Fetch offers
      const res = await callApi(
        `v1/loan_offer/lead_id/${leadId}`,
        "get",
        {},
        "core"
      );

      if (!(res.status === "Success" && res.data?.offers?.length > 0)) {
        setIsFinished(true);
        return false;
      }

      // 2️⃣ Update priority API
      const priorityRes = await callApi(
        `v1/finbud_data/finbud_update_priority/${leadId}`,
        "post",
        res,
        "loan"
      );

      if (
        !(
          priorityRes.status === "Success" &&
          Array.isArray(priorityRes.data?.offers)
        )
      ) {
        setIsFinished(true);
        return false;
      }

      let offers = priorityRes.data.offers;

      // 3️⃣ Fetch lender details (Successlist + FailList)
      const lenderListRes = await callApi(
        `v1/lender_api_call/${leadId}/get-fail-success-lenders`,
        "post",
        {},
        "loan",
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OGZiMDcxNThiMWU2NTNiNTVhYmY2YWMiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk2OTMxMzU0NjYiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMC0yNFQwNTowNjo1My40MDJaIiwiaWF0IjoxNzYxMjgxODE4fQ.sdWP9XYj_22Gr-Qiq4spi4-hmTdadD53Py-8I9XqbbU"
      );

      // 4️⃣ Create map from Successlist (new response)
      let lenderMap = {};
      if (
        lenderListRes.status === "Success" &&
        Array.isArray(lenderListRes.data?.Successlist)
      ) {
        lenderMap = Object.fromEntries(
          lenderListRes.data.Successlist.map((lender) => [
            lender.lender_id,
            lender,
          ])
        );
      }


      if( Array.isArray(lenderListRes.data?.FailList)){

       setFailedList(lenderListRes.data?.FailList)

      }

      // 5️⃣ Enrich each offer with lender details from Successlist
      const enrichedOffers = offers.map((offer) => {
        const lender = lenderMap[offer.lender_id] || {};

        return {
          ...offer,
          apr: lender.apr ?? "",
            kfs_doc: lender.kfs_doc ?? "",
            credit_limit: lender.web_offer?? "",
          penal_charges: lender.penal_charges ?? "",
          processing_fee: lender.processing_fee ?? "",
         interest_rate: lender.web_interest ?? null, // <-- new field name
          lender_name: lender.lender_name ?? offer.lender_name,
          
        };
      });

      // 6️⃣ Sort by priority
      const sortedOffers = _.orderBy(enrichedOffers, ["priority"], ["asc"]);

      // 7️⃣ Dispatch to redux
      dispatch(setOffers(sortedOffers));

      // 8️⃣ Handle finish state
      const lead = priorityRes.data.lead;
      if (lead?.all_responses) {
        setIsFinished(lead.all_responses === lead.total_response);
      } else {
        setIsFinished(true);
      }

      return true;
    } catch (err) {
      console.error("Error in offer fetching", err);
      setIsFinished(true);
      toast.error("Something went wrong while fetching offers.");
      return false;
    }
  };

  return (
    <div className={"landing-page-container2"} style={{}}>
      <div className={"landing-page-v3"}>
        <Header isOfferPage={showOfferHeaderLogo} />
      </div>

      <div>
        <div id="personal-loan-form">
          {currentStep === 1 && (
            <OfferPage
              formData={formData}
              setFormData={setFormData}
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
              isFinished={isFinished}
              affId={affId}
              utmSource={utmSource}
              source={source}
              failedList={failedList}
              utmMedium={utmMedium}
              utmTerm={utmTerm}
              setShowOfferHeaderLogo={setShowOfferHeaderLogo}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
